var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-icon',{style:({ color: _vm.value }),attrs:{"left":""}},[_vm._v("brightness_1")]),_vm._v(" "+_vm._s(_vm.value))],1)}
var staticRenderFns = []

export { render, staticRenderFns }